export const InvoiceIcon = ({ invoice }: { invoice: { status: string } }) => {
  if (invoice.status === 'paid') {
    return <i className='fa-check-circle fas me-2 text-success' />;
  }
  return <></>;
};
